import UgcNewConfirmDesign from "./NewConfirmDesign";

export default UgcNewConfirmDesign;
